import { axios, BaseApiUrl } from '../axios_config';

// 获取移动端进仓单库存
export const getInventoryInfo = params =>{
    return axios.get(`${BaseApiUrl}/TFMobile/GetInventoryInfo`, { params }).then(res => res.data);
}
// 保存盘点操作
export const saveInventoryInfo = params =>{
    return axios.post(`${BaseApiUrl}/TFMobile/SaveInventoryInfo`, { ...params }).then(res => res.data);
}
